import React, { useState } from "react"

import { ChangePassword } from "../apis/UserSessionAPI"
import Row from "../ui-components/Row"
import Col from "../ui-components/Col"
import PasswordInput from "../ui-components/PasswordInput"
import SubmitButton from "../ui-components/SubmitButton"
import BrowserLocationHelper from "../utils/browser_location_helper"

import style from "./ChangeUserPasswordApp.module"

export default function ChangeUserPasswordApp(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const { token } = props

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  const [state, setState] = useState({
    password: "",
    error: false,
    submitDisabled: false,
  })

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  function handlePasswordChanged(event) {
    setState({ ...state, password: event.target.value })
  }

  function handleSubmit(event) {
    event.preventDefault()

    setState({ ...state, error: false, submitDisabled: true })

    ChangePassword(state.password, token)
      .then((res) => {
        BrowserLocationHelper.ChangeURL("/")
      })
      .catch((error) => {
        setState({ ...state, error: true, submitDisabled: false })
      })
  }

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  // -------------------------------------

  return (
    <div>
      <div className={style.title}>
        {I18n.t("pages.user_session.passwords.change_password")}
      </div>

      <div className={style.desc}>
        {I18n.t("pages.user_session.passwords.change_password_desc")}
      </div>

      <form className={style.input} onSubmit={handleSubmit}>
        <Row>
          <Col className="col-sm-12">
            <PasswordInput
              name="user_password"
              value={state.password}
              placeholder={I18n.t("pages.user_session.user.password")}
              onChange={handlePasswordChanged}
            />
          </Col>
        </Row>

        {state.error && (
          <Row>
            <Col className="col-sm-12">
              <div className="alert alert-danger">
                {I18n.t("pages.user_session.passwords.cannot_change_password")}
              </div>
            </Col>
          </Row>
        )}

        <Row>
          <Col className="col-sm-12">
            <SubmitButton
              className={`btn btn-primary ${style.submit}`}
              disabled={state.submitDisabled}
              value={I18n.t(
                "pages.user_session.passwords.submit_change_password"
              )}
            />
          </Col>
        </Row>
      </form>
    </div>
  )
}
